import { useRoute } from "wouter";

import { CheckResults } from "../../components/alle-check/CheckResults";
import { useAlleCheckSubmission } from "../../lib/alle-check-client";
import { localeOf, useLang, useT } from "../../i18n/language";

export function ResultPage() {
  const t = useT();
  const { lang } = useLang();
  const [, params] = useRoute<{ id: string }>("/alle-check/r/:id");
  const id = params?.id;
  const q = useAlleCheckSubmission(id);

  if (!id) return <div className="card"><h2>{t("Geen ID opgegeven.")}</h2></div>;
  if (q.isLoading) return <div className="card">{t("Laden...")}</div>;
  if (q.isError) return <div className="error-box">{t("Kon resultaat niet laden:")} {q.error.message}</div>;
  if (!q.data) return <div className="card">{t("Niet gevonden.")}</div>;

  return (
    <>
      <section className="card">
        <div style={{ fontSize: 12, color: "var(--color-muted)" }}>
          Submission {q.data.id} · {new Date(q.data.created_at).toLocaleString(localeOf(lang))}
        </div>
      </section>
      <CheckResults result={q.data.result} submissionId={q.data.id} />
    </>
  );
}
